import { Box, Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { repositoryMdm } from "../../_base/_const/_constVar";
import { MessageResponse } from "../../model/MessageResponse";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";

const DeleteReasonForReturn = ({ idItems, onReload }: DeleteProduct) => {
  const handleDeleteReasonReturn = async () => {
    const res = await repositoryMdm.post<MessageResponse<boolean>>(
      "/api/v1/TblDmReturnReason/delete",
      idItems
    );
    if (res)
      if (res.success) {
        onReload && onReload();
        setTimeout(() => {
          NotificationExtension.Success("Xóa thành công !");
        }, 1000);
      } else NotificationExtension.Fails("Xóa thất bại !");
    modals.closeAll();
  };

  return (
    <Box size={"auto"}>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="gray"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
        <Button
          type="button"
          color="red"
          onClick={handleDeleteReasonReturn}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
      </Group>
    </Box>
  );
};

type DeleteProduct = {
  idItems: (number | string)[];
  onReload?: () => void;
};

export default DeleteReasonForReturn;
